/* eslint-disable react/no-array-index-key */

import {
  Box,
  Button,
  Checkbox,
  Col,
  Feedback,
  Flex,
  HStack,
  Image,
  Label,
  Link,
  Radio,
  RadioGroup,
  Row,
  Text,
} from '@hausgold/designsystem';
import {
  AccountStar,
  ArrowRightDrop,
  Check,
  Lock,
  Star,
} from '@hausgold/designsystem/icons';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { ApiContext, WizardContext } from 'fw-utils/contexts';
import analyticsTrack from 'fw-utils/tracking';
import 'fw-utils/yupPhone';
import { Parser } from 'html-to-react';
import { map } from 'lodash-es';
import React, { Fragment, useContext, useState } from 'react';
import * as Yup from 'yup';
import { isIframe } from 'fw-utils/isEnv';
import FluidMaxContainer from '../components/FluidMaxContainer';
import Input from '../components/Input';
import formwizardApi from '../services/api/formwizardApi';
import {
  getAdditionalContentText,
  getAuthenticityToken,
  getContactDescriptionText,
  getMandatoryFieldOptions,
  getNextButtonText,
  getOptinContentText,
  getOptinType,
  getVersion,
} from '../services/models/dialog';

const PLACEHOLDER_IMAGE =
  'data:image/jpeg;base64,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';

const htmlToReactParser = new Parser();

/**
 * Get `html-to-react` processing instructions
 * @param type {'default'|'additionalContent'}
 * @return {[{shouldProcessNode: (function(*): boolean), processNode: (function(*): *)}]}
 */
const getHtmlToReactParserProcessingInstructions = (type = 'default') => [
  {
    // This processing instruction correctly processes various tags, but removes the `<p />` tag
    // outside.
    //
    // We have to render links as `<Link />`, for example.
    shouldProcessNode: (node) => node.name === 'p',
    processNode: (node) =>
      map(node.children, (child, index) => {
        if (child.type === 'comment') {
          return null;
        }

        if (child.name === 'a') {
          return (
            <Link
              {...child.attribs}
              fontSize="inherit"
              key={index}
              colorScheme={type !== 'additionalContent' ? 'gray' : 'blue'}
              textDecoration={type !== 'additionalContent' && 'underline'}
            >
              {child.children.map((subChild) => subChild.data)}
            </Link>
          );
        }

        if (child.name === 'br') {
          return <br key={index} />;
        }

        if (child.name === 'strong') {
          return (
            <strong key={index}>
              {child.children.map((subChild) => subChild.data)}
            </strong>
          );
        }

        return child.data;
      }),
  },
];

/**
 * Build validation schema
 * @param mandatoryFields
 */
const buildValidationSchema = (mandatoryFields) =>
  Yup.object().shape({
    gender: mandatoryFields.gender
      ? Yup.string().required('Bitte wählen Sie eine Anrede aus.')
      : Yup.string(),
    firstName: mandatoryFields.firstName
      ? Yup.string().trim().required('Bitte geben Sie Ihren Vornamen ein.')
      : Yup.string(),
    lastName: mandatoryFields.lastName
      ? Yup.string().trim().required('Bitte geben Sie Ihren Nachnamen ein.')
      : Yup.string(),
    email: Yup.string()
      .email(
        'Geben Sie eine gültige E-Mail-Adresse für die kostenlose Immobilienbewertung an.'
      )
      .required(
        'Geben Sie eine gültige E-Mail-Adresse für die kostenlose Immobilienbewertung an.'
      ),
    phone: Yup.string()
      .phone(
        'DE',
        false,
        'Geben Sie eine gültige Telefonnummer für die kostenlose Immobilienbewertung an.'
      )
      .trim()
      .required(
        'Geben Sie eine gültige Telefonnummer für die kostenlose Immobilienbewertung an.'
      ),
    optIn: mandatoryFields.optIn
      ? Yup.bool().oneOf(
          [true],
          'Bitte akzeptieren Sie die Datenschutzbestimmungen.'
        )
      : Yup.mixed(),
  });

const UserDataStep = () => {
  const { data, config, setRedirectUrl } = useContext(ApiContext);

  const {
    setUserData,
    userData,
    dialogId,
    currentLine,
    leadId,
    recruiterId,
    stepData,
    position,
    components: { UserDataStepLayoutContainer },
  } = useContext(WizardContext);

  const [isLoading, setIsLoading] = useState(false);
  const optinType = getOptinType(data) || 'hint';

  const mandatoryFields = getMandatoryFieldOptions(data);

  let firstColWidth = {
    base: 1 / 1,
    md: 7 / 12,
  };

  let secondColWidth = {
    base: 1 / 1,
    md: 5 / 12,
  };

  let firstLastNameColWidth = {
    base: 1,
    md: 1 / 2,
  };

  let serviceDirection = {
    base: 'column',
    sm: 'row',
  };

  let serviceMarginLeft = {
    base: '0',
    sm: 'auto',
  };

  let secondColDisplay = {
    base: 'none',
    md: 'block',
  };

  /**
   * Special breakpoints for variants
   */
  if (position === 'right' || position === 'top') {
    firstColWidth = {
      base: 1 / 1,
      sm: 7 / 12,
      lg: 1 / 1,
    };

    secondColWidth = {
      base: 1 / 1,
      sm: 5 / 12,
      lg: 1 / 1,
    };

    firstLastNameColWidth = {
      base: 1,
      sm: 1 / 2,
      lg: 1,
    };

    serviceDirection = {
      base: 'column',
      sm: 'row',
      lg: 'column',
    };

    serviceMarginLeft = {
      base: '0',
      sm: 'auto',
      lg: '0',
    };

    secondColDisplay = {
      base: 'none',
      sm: 'block',
      lg: 'none',
    };
  }

  return (
    <FluidMaxContainer>
      <UserDataStepLayoutContainer>
        <Row>
          <Col width={firstColWidth}>
            <Formik
              initialValues={userData}
              validationSchema={buildValidationSchema({
                gender: mandatoryFields?.gender ?? true,
                firstName: mandatoryFields?.first_name ?? true,
                lastName: mandatoryFields?.last_name ?? true,
                optIn: optinType === 'checkbox' && getOptinContentText(data),
              })}
              onSubmit={(values) => {
                formwizardApi()
                  .processLead({
                    config,
                    currentLine,
                    data,
                    dialogId,
                    recruiterId,
                    leadId,
                    stepData,
                    values,
                    getAuthenticityToken,
                    getVersion,
                    setIsLoading,
                    setUserData,
                  })
                  .then(({ createdLeadId, redirectUrl }) => {
                    // Send a post message to our embedding host, when we
                    // finished the lead submit
                    if (isIframe) {
                      window.parent.postMessage(
                        {
                          type: 'lead_submitted',
                          target: '#hausgold-wizard',
                          leadId: createdLeadId,
                        },
                        '*'
                      );
                    }

                    // Extended wizard should only be shown for some types
                    const isSpecificType =
                      currentLine === 'haus' ||
                      currentLine === 'wohnung' ||
                      currentLine === 'gewerbe';

                    // Used for extended wizard to skip redirect to VP but save the url for later
                    if (data.extendedWizard && isSpecificType) {
                      setRedirectUrl(redirectUrl);
                      return;
                    }

                    // Track last user interaction
                    analyticsTrack({
                      event: 'Formwizard Finished',
                      params: {
                        dialog_id: dialogId,
                        lead_id: leadId,
                        recruiter_id: recruiterId,
                        label: 'last_click',
                      },
                    });

                    // Redirect to the success page,
                    // when the lead submission was completed successfully
                    //
                    // NOTE: Use +window.top.location+ to break out of the
                    //       iframe (redirect the whole page/tab).
                    window.location.href = redirectUrl;
                  });
              }}
            >
              {/* FIXME: No error message for firstName & gender?! */}
              <Form>
                <Text fontSize="lg">{getContactDescriptionText(data)}</Text>
                <Box mb={3}>
                  <Flex alignItems="center">
                    <Text as="span" mr={6} mb={0} fontSize="lg">
                      Anrede
                      {mandatoryFields.gender ? '*' : ''}
                    </Text>

                    <RadioGroup name="gender">
                      <HStack>
                        <Field name="gender" value="male">
                          {({ field, meta }) => (
                            <Fragment>
                              <Radio
                                isInvalid={Boolean(meta.touched && meta.error)}
                                id={`${field.name}-male`}
                                {...field}
                                value="male"
                              >
                                Herr
                              </Radio>
                            </Fragment>
                          )}
                        </Field>

                        <Field name="gender" value="female">
                          {({ field, meta }) => (
                            <Fragment>
                              <Radio
                                isInvalid={Boolean(meta.touched && meta.error)}
                                id={`${field.name}-female`}
                                {...field}
                                value="female"
                              >
                                Frau
                              </Radio>
                            </Fragment>
                          )}
                        </Field>
                      </HStack>
                    </RadioGroup>
                  </Flex>
                  <ErrorMessage name="gender" component={Feedback} />
                </Box>
                <Row>
                  <Col mb={3} width={firstLastNameColWidth}>
                    <Field name="firstName">
                      {({ field, meta }) => (
                        <Fragment>
                          <Input
                            isInvalid={Boolean(meta.touched && meta.error)}
                            id={field.name}
                            width="100%"
                            placeholder={`Vorname${
                              mandatoryFields.first_name ? ' *' : ''
                            }`}
                            {...field}
                          />
                          <ErrorMessage
                            name={field.name}
                            component={Feedback}
                          />
                        </Fragment>
                      )}
                    </Field>
                  </Col>
                  <Col mb={3} width={firstLastNameColWidth}>
                    <Field name="lastName">
                      {({ field, meta }) => (
                        <Fragment>
                          <Input
                            isInvalid={Boolean(meta.touched && meta.error)}
                            id={field.name}
                            width="100%"
                            placeholder={`Nachname${
                              mandatoryFields.last_name ? ' *' : ''
                            }`}
                            {...field}
                          />
                          <ErrorMessage
                            name={field.name}
                            component={Feedback}
                          />
                        </Fragment>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Box mb={3}>
                  <Field name="email">
                    {({ field, meta }) => (
                      <Fragment>
                        <Input
                          isInvalid={Boolean(meta.touched && meta.error)}
                          type="email"
                          id={field.name}
                          width="100%"
                          placeholder="E-Mail *"
                          {...field}
                        />
                        <ErrorMessage name={field.name} component={Feedback} />
                      </Fragment>
                    )}
                  </Field>
                </Box>
                <Box mb={3}>
                  <Field name="phone">
                    {({ field, meta }) => (
                      <Fragment>
                        <Input
                          isInvalid={Boolean(meta.touched && meta.error)}
                          type="tel"
                          id={field.name}
                          width="100%"
                          placeholder="Telefon *"
                          {...field}
                        />
                        <ErrorMessage name={field.name} component={Feedback} />
                      </Fragment>
                    )}
                  </Field>
                </Box>

                {optinType === 'checkbox' && getOptinContentText(data) && (
                  <Field name="optIn">
                    {({ field, meta }) => (
                      <Box mb={7}>
                        <Flex>
                          <Checkbox
                            isInvalid={Boolean(meta.touched && meta.error)}
                            id={field.name}
                            {...field}
                          />
                          <Label
                            isRequired
                            color="gray.400"
                            htmlFor={field.name}
                          >
                            {htmlToReactParser.parseWithInstructions(
                              getOptinContentText(data),
                              () => true,
                              getHtmlToReactParserProcessingInstructions()
                            )}
                          </Label>
                        </Flex>
                        <ErrorMessage name={field.name} component={Feedback} />
                      </Box>
                    )}
                  </Field>
                )}

                <Text textAlign="right" mb={2} color="gray.400">
                  * Pflichtfelder
                </Text>

                <Flex flexDirection={serviceDirection} alignItems="center">
                  <div>
                    <Button
                      id="button--userdata-submit"
                      variant="primary"
                      isLoading={isLoading}
                      type="submit"
                      px={16}
                    >
                      <Fragment>
                        {getNextButtonText(data)}
                        <ArrowRightDrop ml={[1.5, 1.5, 2.5]} boxSize={3} />
                      </Fragment>
                    </Button>
                  </div>
                  <Box ml={serviceMarginLeft}>
                    <Text
                      fontSize={['sm', 'md']}
                      mb={0}
                      fontStyle="italic"
                      textAlign="center"
                    >
                      Dieser Service ist 100%
                      <Box as="br" display={['none', 'inline']} /> unverbindlich
                      &amp; kostenlos!
                    </Text>
                  </Box>
                </Flex>

                {optinType === 'hint' && getOptinContentText(data) && (
                  <Text
                    as="span"
                    mt={7}
                    mb={0}
                    fontSize="sm"
                    color="gray.400"
                    display="block"
                  >
                    {htmlToReactParser.parseWithInstructions(
                      getOptinContentText(data),
                      () => true,
                      getHtmlToReactParserProcessingInstructions()
                    )}
                  </Text>
                )}
              </Form>
            </Formik>
          </Col>

          <Col width={secondColWidth} fontSize="md">
            <Box display={secondColDisplay}>
              <Text>
                <Check color="green.400" boxSize={4} /> Nur qualifizierte
                Experten
                <br />
                <Check color="green.400" boxSize={4} /> Kostenlose Bewertung vor
                Ort
                <br />
                <Check color="green.400" boxSize={4} /> Unabhängige Beratung
              </Text>

              <Box
                mb={5}
                p={2}
                borderWidth={0.5}
                borderColor="green.400"
                borderStyle="solid"
                boxShadow="sm"
                overflow="hidden"
              >
                <Box mr={4} sx={{ float: 'left' }}>
                  <Image
                    height="97px"
                    width="73px"
                    // Limit width if alt text is shown instead of the picture
                    maxWidth="75px"
                    src={PLACEHOLDER_IMAGE}
                    alt="Portrait von Anna M. aus Hannover"
                  />
                </Box>
                <Box overflow="hidden">
                  <Text mb={3.5}>
                    Der Verkaufspreis meiner Wohnung war viel höher, als ich
                    erwartet hatte. Toller Service und ein kompetenter Makler -
                    kann ich nur weiterempfehlen!
                  </Text>
                  <Text as="span" color="gray.400">
                    Anna M. aus Hannover
                  </Text>
                </Box>
              </Box>

              <Flex textAlign="center" alignItems="center" ml={0}>
                <Box width={1 / 3}>
                  <Star mb={2} color="green.400" boxSize={6} />
                  <Text fontSize="sm" color="gray.400">
                    Hohe Kunden&shy;zufriedenheit
                  </Text>
                </Box>
                <Box width={1 / 3}>
                  <Lock mb={2} color="green.400" boxSize={6} />
                  <Text fontSize="sm" color="gray.400">
                    Sichere
                    <br />
                    Übertragung
                  </Text>
                </Box>
                <Box width={1 / 3}>
                  <AccountStar mb={2} color="green.400" boxSize={6} />
                  <Text fontSize="sm" color="gray.400">
                    Qualifizierte
                    <br />
                    Top-Experten
                  </Text>
                </Box>
              </Flex>
            </Box>
            {getAdditionalContentText(data) && (
              <Text
                as="span"
                mt={7}
                mb={0}
                fontSize="sm"
                color="gray.400"
                display="block"
              >
                {htmlToReactParser.parseWithInstructions(
                  getAdditionalContentText(data),
                  () => true,
                  getHtmlToReactParserProcessingInstructions(
                    'additionalContent'
                  )
                )}
              </Text>
            )}
          </Col>
        </Row>
      </UserDataStepLayoutContainer>
    </FluidMaxContainer>
  );
};

export default UserDataStep;
